<template>
  <div>
    <CustomError v-if="is_error" />
    <Loading v-if="is_loading" />
    <div v-if="!is_loading">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <h1>Order ID: {{ order._id }}</h1>
        </v-col>
        <v-col class="d-flex" cols="12" sm="2">
          <v-select
            :items="getStatusesTitles()"
            v-model="order.data.status"
            outlined
            label="Order status"
            @change="changed(order)"
          ></v-select>
        </v-col>
      </v-row>
      <v-row
        ><h2>Date: {{ order_date(order) }}</h2></v-row
      >
      <v-simple-table v-if="!isloading">
        <thead>
          <tr>
            <th class="text-left">Title</th>
            <th class="text-left">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="key in Object.keys(order.data.fields).filter(
              v => typeof order.data.fields[v] == 'object'
            )"
            :key="key"
          >
            <td>{{ key }}</td>
            <td>
              {{ getOrderText(order.data.fields[key]) }}
              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                    v-if="order.data.fields[key].comment"
                    :value="order.data.fields[key].comment"
                    auto-grow
                    outlined
                    rounded
                    :rows="2"
                    solo
                    readonly
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
            </td>
          </tr>
          <tr
            v-for="key in Object.keys(order.data.fieldsFixed).filter(
              v => typeof order.data.fieldsFixed[v] == 'object'
            )"
            :key="key"
          >
            <td>{{ key }}</td>
            <td>
              {{ getOrderText(order.data.fieldsFixed[key]) }}
              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                    v-if="order.data.fieldsFixed[key].comment"
                    :value="order.data.fieldsFixed[key].comment"
                    auto-grow
                    outlined
                    rounded
                    :rows="2"
                    solo
                    readonly
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-textarea
        v-if="order.data.comment"
        :value="order.data.comment"
        auto-grow
        outlined
        rounded
        :rows="2"
        solo
        readonly
        filled
      ></v-textarea>
    </div>
    <v-btn color="success" @click="goBack">Back</v-btn>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import CustomError from '@/components/CustomError'
import { dateDisplaySettings } from './settings'

import ORDER_STATUSES from '@/constants/orderStatuses'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    Loading,
    CustomError
  },
  computed: {
    order() {
      return this.getEditedOrder()
    },
    is_loading() {
      return this.isLoading()
    },
    is_error() {
      return this.isError()
    }
  },
  methods: {
    ...mapGetters('order', ['getEditedOrder', 'isLoading', 'isError']),
    ...mapActions('order', ['loadOrderById']),
    ...mapActions('orders', ['update']),
    order_date(order) {
      return new Date(order.createdAt).toLocaleDateString(...Object.values(dateDisplaySettings))
    },
    changed(item) {
      this.update(item)
    },
    getStatusesTitles() {
      return Object.keys(ORDER_STATUSES)
        .filter(key => ORDER_STATUSES[key].text)
        .map(key => ({
          text: ORDER_STATUSES[key].text,
          value: key
        }))
    },
    getItemCount(item) {
      if (item.count) return `(${item.count})`
      return ''
    },
    getItemPrice(item) {
      if (item.price) {
        if (item.count) return ` - $ ${item.count * item.price}`
        else return ` - $ ${item.price}`
      }
      return ''
    },
    getOrderText(value) {
      if (value == undefined) return ''
      if (Array.isArray(value)) {
        return value
          .map(item => `${item.text}${this.getItemCount(item)} ${this.getItemPrice(item)}`)
          .join(', ')
      }
      if (value.hasOwnProperty('text')) {
        return `${value.text}${this.getItemCount(value)} ${this.getItemPrice(value)}`
      }
      return value
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.loadOrderById(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped></style>
